import { Col, Label, Row } from "reactstrap";
import { NumberInputField } from "../../../CommonElements";

const TahunFilterComponent = ({ updateTahunFilter }) => {
  return (
    <Row className={"align-items-center"}>
      <Col md={4}>
        <Label className={"m-0"}>Tahun</Label>
      </Col>
      <Col md={8}>
        <NumberInputField
          // label={"Tahun"}
          className={"m-0"}
          onChange={(e) => {
            updateTahunFilter(e.target.value);
          }}
          defaultValue={new Date().getFullYear()}
        />
      </Col>
    </Row>
  );
};

export default TahunFilterComponent;
